import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SystemFile } from '../../../domain/common.model';

@Injectable()
export class FileService {

    constructor(private http: HttpClient) {
    }

    public getTokenByHash(hash: string) {
        this.http.get<SystemFile>(`/api/secured/file/${hash}`)
            .subscribe(object => {
                this.getFileByToken(object.token);
            });
    }

    public getFileByToken(token: string) {
        window.location.href = `/api/secured/file/download/${token}`;
    }

    getIOfferFileByToken(token: string) {
        window.location.href = `/api/public/ioffer/file/download/${token}`;
    }
}
